/**
 * Selection state reducer
 * Manages row selection state (selected rows, checkboxes)
 */

export const selectionReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SELECT_ALL':
      return { ...state, selectAll: action.payload };
    
    case 'SET_LAST_SELECTED_ROW_INDEX':
      return { ...state, lastSelectedRowIndex: action.payload };
    
    case 'SET_SELECT_ALL_BY_PAGE':
      return { ...state, selectAllByPage: action.payload };
    
    case 'SET_SELECTED_ROWS':
      return { ...state, selectedRows: action.payload };
    
    case 'ADD_SELECTED_ROW':
      return {
        ...state,
        selectedRows: [...state.selectedRows, action.payload],
      };
    
    case 'REMOVE_SELECTED_ROW':
      return {
        ...state,
        selectedRows: state.selectedRows.filter(
          (row) => row._id !== action.payload._id
        ),
      };
    
    case 'CLEAR_SELECTION':
      return {
        ...state,
        selectAll: false,
        selectedRows: [],
      };
    
    default:
      return state;
  }
};

export const initialSelectionState = {
  selectAll: false,
  lastSelectedRowIndex: null,
  selectAllByPage: {},
  selectedRows: [],
};

